// extracted by mini-css-extract-plugin
export default {"card":"h8-z"};